import { cn } from "@/lib/utils";

export function ReportSection({ number, title, children, className }) {
  return (
    <section className={cn("report-section space-y-4", className)}>
      <header className="flex items-end justify-between gap-4 border-b border-border pb-3">
        <div className="flex items-baseline gap-3">
          <span className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
            {number} /
          </span>
          <h3 className="font-display text-xl font-medium leading-tight text-foreground sm:text-2xl">
            {title}
          </h3>
        </div>
      </header>
      <div className="space-y-3 text-[15px] leading-relaxed text-foreground">{children}</div>
    </section>
  );
}
